// extracted by css-extract-rspack-plugin
export default {"labels":"labels-zIgnAX","receivingLabel":"receivingLabel-j3YZYn","rejectedLabel":"rejectedLabel-LvBtLb","remainingLabel":"remainingLabel-z0duvg"};